<template>
	<div class="page-barcode-bind">
		<!-- 头部 -->
		<div class="header">
			<div class="header-info">
				<div class="header-title">设备列表</div>
				<div class="header-count">当前已录入{{ list.length }}台设备</div>
			</div>
			<div class="header-record-btn" @click="onclickRecordBtn">记 录</div>
		</div>

		<!-- 设备列表 -->
		<div class="list" v-if="list.length">
			<div class="item" v-for="(item, index) in list" :key="index">
				<div class="item-left">
					<img class="icon-feeder" :src="ossPondHost + 'img/xiazeng_icon.png'" />
					<div class="item-info">
						<div class="item-unique-id">{{ item.uniqueId }}</div>
						<div class="item-barcode">{{ item.barcode }}</div>
					</div>
				</div>
				<div class="item-remove-btn" @click="onclickRemoveBtn(index)">移除</div>
			</div>
		</div>

		<!-- 空状态 -->
		<div class="empty-box" v-if="!list.length">
			<img :src="ossPondHost + 'img/empty_controller.png'" />
			<div class="empty-tip">暂未录入设备,请点击+号录入</div>
		</div>

		<!-- 底部提交按钮 -->
		<div class="footer">
			<div :class="['btn-submit', { disabled: !list.length || submitting }]" @click="onclickSubmitBtn">确认提交</div>
		</div>

		<!-- 悬浮添加按钮 -->
		<div class="fab-add" @click="showAddDialog = true">
			<span class="fab-icon">+</span>
		</div>

		<!-- 添加设备弹框 -->
		<div class="dialog-mask" v-if="showAddDialog" @click.self="closeDialog">
			<div class="dialog-content">
				<div class="dialog-scan-icon">
					<img :src="ossPondHost + 'img/xiazeng_icon.png'" />
				</div>

				<!-- 设备号 -->
				<div class="dialog-field">
					<span class="field-label">设备号</span>
					<div class="field-right" v-if="!addForm.uniqueId" @click="onclickScanDevice">
						<span class="field-scan-text">扫码录入</span>
					</div>
					<div class="field-right" v-else>
						<span class="field-value">{{ addForm.uniqueId }}</span>
						<span class="field-rescan" @click="onclickScanDevice">重扫</span>
					</div>
				</div>

				<!-- 条形码 -->
				<div class="dialog-field">
					<span class="field-label">条形码</span>
					<div class="field-right" v-if="!addForm.barcode" @click="onclickScanBarcode">
						<span class="field-scan-text">扫码录入</span>
					</div>
					<div class="field-right" v-else>
						<span class="field-value">{{ addForm.barcode }}</span>
						<span class="field-rescan" @click="onclickScanBarcode">重扫</span>
					</div>
				</div>

				<!-- 批次号 -->
				<div class="dialog-field">
					<span class="field-label">批次号</span>
					<div
						class="field-right field-right-batch"
						:class="{ disabled: !batchList.length }"
						@click="onclickBatchField"
					>
						<span :class="['field-batch-text', { placeholder: !addForm.batchName && batchList.length }]">
							{{ addForm.batchName || (batchList.length ? '请选择' : '未获取到批次号') }}
						</span>
						<Icon name="arrow-down" class="field-arrow" />
					</div>
				</div>

				<!-- 按钮组 -->
				<div class="dialog-buttons">
					<div class="dialog-btn dialog-btn-cancel" @click="closeDialog">{{ list.length > 0 ? '结束录入' : '取 消' }}</div>
					<div :class="['dialog-btn', 'dialog-btn-confirm', { disabled: !batchList.length }]" @click="onclickConfirmAdd">确 定</div>
				</div>
			</div>
		</div>

		<!-- 批次号选择器 -->
		<div class="picker-mask" v-if="showBatchPicker" @click.self="showBatchPicker = false">
			<div class="picker-content">
				<div class="picker-header">
					<span class="picker-cancel" @click="showBatchPicker = false">取消</span>
					<span class="picker-title">选择批次号</span>
					<span class="picker-confirm" @click="showBatchPicker = false">确定</span>
				</div>
				<div class="picker-list">
					<div
						class="picker-item"
						v-for="(item, index) in batchList"
						:key="index"
						:class="{ active: addForm.batchName === item.batchName }"
						@click="onSelectBatch(item)"
					>
						{{ item.batchName }}
					</div>
					<div class="picker-empty" v-if="!batchList.length">未获取到批次号</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Dialog, Icon, Toast } from 'vant';
export default {
	name: 'XiazengBarcodeBindList',
	components: {
		Icon,
	},
	data() {
		const { ossHost, ossHostPond } = this.$config.base;
		return {
			ossHost,
			ossPondHost: ossHostPond,
			list: [],
			submitting: false,
			showAddDialog: false,
			showBatchPicker: false,
			addForm: {
				uniqueId: '',
				barcode: '',
				// 批次ID，提交时使用
				batchId: '',
				// 展示名
				batchName: '',
				// 真实批次号，提交时使用
				batchNo: '',
			},
			batchList: [],
		};
	},
	created() {
		this.weixinInit();
		this.loadBatchList();
	},
	beforeRouteLeave(to, from, next) {
		// 退出到 index 页时清空数据，下次进入重新开始
		if (to.path === '/xiazeng/index') {
			this.list = [];
			this.addForm = { uniqueId: '', barcode: '', batchId: '', batchName: '', batchNo: '' };
			this.showAddDialog = false;
			this.showBatchPicker = false;
		}
		next();
	},
	methods: {
		// 微信 JSSDK 初始化
		weixinInit() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: `https://m.yudada.com/jssdk/configuration?url=${location.href}`,
			}).then(res => {
				const { appId, nonceStr, signature, timestamp } = res.data;
				window.wx.config({
					debug: false,
					appId,
					timestamp,
					nonceStr,
					signature,
					jsApiList: ['scanQRCode'],
				});
			});
		},

		// 加载批次号列表
		loadBatchList() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/batch/active',
			}).then(res => {
				const batchList = Array.isArray(res.data) ? res.data : [];
				vm.batchList = batchList;
				// 默认选第一个
				if (batchList.length && !vm.addForm.batchName) {
					vm.addForm.batchId = batchList[0].id;
					vm.addForm.batchName = batchList[0].batchName;
					vm.addForm.batchNo = batchList[0].batchNo;
				}
			}).catch(() => {});
		},

		// 选择批次号
		onSelectBatch(item) {
			this.addForm.batchId = item.id;
			this.addForm.batchName = item.batchName;
			this.addForm.batchNo = item.batchNo;
			this.showBatchPicker = false;
		},

		// 扫码获取设备号（二维码 -> 解析接口 -> 8位 uniqueId）
		onclickScanDevice() {
			const vm = this;
			if (window.wx && window.wx.scanQRCode) {
				window.wx.scanQRCode({
					needResult: 1,
					scanType: ['qrCode'],
					success(res) {
						const result = res.resultStr;
						if (!(result && result.split('deviceId=')[1])) {
							Toast('编号错误，请确认后重试');
							return;
						}
						const encodeId = result.split('deviceId=')[1];
						vm.$http({
							method: 'GET',
							url: vm.$config.base.PROBE_BASE_URL + `device/info?encodeId=${encodeId}`,
						}).then(rs => {
							vm.addForm.uniqueId = rs.data.uniqueId;
						});
					},
				});
			} else {
				Toast('请在微信中扫码');
			}
		},

		// 扫码获取条形码
		onclickScanBarcode() {
			const vm = this;
			if (window.wx && window.wx.scanQRCode) {
				window.wx.scanQRCode({
					needResult: 1,
					scanType: ['barCode'],
					success(res) {
						// 条形码扫码结果格式为 "条码类型,条码内容"，如 CODE_128,123456，截取第一个逗号后的内容
						let result = res.resultStr || '';
						const commaIndex = result.indexOf(',');
						if (commaIndex > -1) {
							result = result.slice(commaIndex + 1);
						}
						vm.addForm.barcode = result;
					},
				});
			} else {
				Toast('请在微信中扫码');
			}
		},

		// 关闭弹框
		closeDialog() {
			this.showAddDialog = false;
		},

		// 点击批次号字段
		onclickBatchField() {
			if (!this.batchList.length) return;
			this.showBatchPicker = true;
		},

		// 确认添加设备到列表
		onclickConfirmAdd() {
			const vm = this;
			if (!vm.batchList.length) {
				Toast('暂无批次号，无法添加设备');
				return;
			}
			if (!vm.addForm.uniqueId) {
				Toast('请扫码录入设备号');
				return;
			}
			if (!vm.addForm.barcode) {
				Toast('请扫码录入条形码');
				return;
			}
			if (!vm.addForm.batchNo) {
				Toast('请选择批次号');
				return;
			}
			// 检查是否已存在相同设备
			const exists = vm.list.some(item => item.uniqueId === vm.addForm.uniqueId);
			if (exists) {
				Toast('该设备已在列表中');
				return;
			}
			vm.list.push({
				uniqueId: vm.addForm.uniqueId,
				barcode: vm.addForm.barcode,
				batchId: vm.addForm.batchId,
				batchName: vm.addForm.batchName,
				batchNo: vm.addForm.batchNo,
			});
			vm.addForm = { uniqueId: '', barcode: '', batchId: vm.addForm.batchId, batchName: vm.addForm.batchName, batchNo: vm.addForm.batchNo };
			vm.showAddDialog = false;
			Toast('录入成功，您可继续扫码录入下一台设备');
		},

		// 移除设备
		onclickRemoveBtn(index) {
			this.list.splice(index, 1);
		},

		// 点击提交按钮 - 二次确认后逐台提交
		onclickSubmitBtn() {
			const vm = this;
			if (!vm.list.length || vm.submitting) return;
			Dialog.confirm({
				title: '是否确认提交',
				message: '提交后设备号将关联条形码，且无法二次修改',
				confirmButtonText: '确 认',
				cancelButtonText: '取 消',
			}).then(() => {
				vm.doSubmitAll();
			}).catch(() => {});
		},

		// 逐台轮询提交
		doSubmitAll() {
			const vm = this;
			const submitList = vm.list.slice();
			vm.submitting = true;
			const toast = Toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });

			let index = 0;
			const submitNext = () => {
				if (index >= submitList.length) {
					toast.clear();
					vm.submitting = false;
					Toast('提交成功');
					vm.list = [];
					vm.addForm = { uniqueId: '', barcode: '', batchId: '', batchName: '', batchNo: '' };
					vm.$router.replace({ path: '/xiazeng/index' });
					return;
				}
				const item = submitList[index];
				vm.$http({
					method: 'POST',
					url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindBarcode',
					params: {
						batchId: item.batchId,
						uniqueId: item.uniqueId,
						barcode: item.barcode,
					},
				}).then(() => {
					index++;
					submitNext();
				}).catch(() => {
					toast.clear();
					vm.submitting = false;
					Toast(`设备${item.uniqueId}提交失败`);
				});
			};
			submitNext();
		},

		// 跳转关联记录页
		onclickRecordBtn() {
			this.$router.push({ path: './barcodeBindRecord' });
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-barcode-bind {
	min-height: 100vh;
	background: @bgColor2;
	padding-bottom: 0.9rem;
	box-sizing: border-box;

	.header {
		padding: 0.15rem 0.1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;

		&-info {
			display: flex;
			flex-direction: column;
		}

		&-title {
			color: @textColor1;
			font-weight: 500;
			font-size: 0.18rem;
			letter-spacing: 0.01rem;
			line-height: 0.25rem;
		}

		&-count {
			color: @textColor1;
			font-size: 0.14rem;
			letter-spacing: 0.01rem;
			line-height: 0.22rem;
			margin-top: 0.05rem;
		}

		&-record-btn {
			background: @themeColor;
			border-radius: 0.25rem;
			color: @blank;
			font-size: 0.16rem;
			letter-spacing: 0.01rem;
			line-height: 0.3rem;
			height: 0.3rem;
			width: 0.8rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.list {
		margin: 0.2rem 0.1rem 0;

		.item {
			background: @blank;
			border-radius: 0.05rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.12rem 0.1rem;
			box-sizing: border-box;
			margin-bottom: 0.1rem;

			&-left {
				display: flex;
				align-items: center;
				flex: 1;
				overflow: hidden;
			}

			.icon-feeder {
				width: 0.55rem;
				height: 0.55rem;
				margin-right: 0.1rem;
				flex-shrink: 0;
			}

			&-info {
				display: flex;
				flex-direction: column;
				overflow: hidden;
			}

			&-unique-id {
				font-size: 0.17rem;
				color: @textColor12;
				font-weight: 500;
				letter-spacing: 0.01rem;
				line-height: 0.24rem;
			}

			&-barcode {
				font-size: 0.14rem;
				color: @textColor13;
				line-height: 0.2rem;
				margin-top: 0.04rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			&-remove-btn {
				border: 2px solid @textColor2;
				border-radius: 0.15rem;
				color: @textColor2;
				font-size: 0.14rem;
				letter-spacing: 0.01rem;
				line-height: 0.22rem;
				padding: 0.02rem 0.08rem;
				text-align: center;
				flex-shrink: 0;
				margin-left: 0.1rem;
				cursor: pointer;
			}
		}
	}

	.empty-box {
		padding: 0.7rem 0.35rem;
		text-align: center;

		img {
			width: 2rem;
			height: 2rem;
			margin: 0 auto 0.15rem;
			display: block;
		}

		.empty-tip {
			font-size: 0.16rem;
			color: @textColor13;
			letter-spacing: 0.01rem;
		}
	}

	.footer {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: @bgColor2;

		.btn-submit {
			background: @themeColor;
			color: @blank;
			font-size: 0.19rem;
			font-weight: 500;
			letter-spacing: 0.02rem;
			line-height: 0.6rem;
			text-align: center;
			cursor: pointer;

			&.disabled {
				background: #C8C9CC;
				cursor: default;
			}
		}
	}

	// 悬浮添加按钮
	.fab-add {
		width: 0.6rem;
		height: 0.6rem;
		background: @blank;
		box-shadow: 0px 0px 5px 0px @themeColor;
		border: 2px solid @themeColor;
		border-radius: 50%;
		position: fixed;
		right: 0.2rem;
		bottom: 0.85rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 10;

		.fab-icon {
			font-size: 0.7rem;
			color: @themeColor;
			line-height: 1;
		}
	}

	// 弹框遮罩
	.dialog-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 100;
	}

	.dialog-content {
		background: @blank;
		border-radius: 0.1rem;
		width: 3.15rem;
		margin: 40% auto 0;
		padding: 0.15rem 0.1rem;
		display: flex;
		flex-direction: column;

		.dialog-scan-icon {
			text-align: center;

			img {
				width: 1rem;
				height: 1rem;
			}
		}

		.dialog-field {
			background: @bgColor2;
			border-radius: 0.05rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0.15rem 0.1rem;
			margin-top: 0.15rem;

			.field-label {
				color: @textColor12;
				font-size: 0.16rem;
				letter-spacing: 0.01rem;
			}

			.field-right {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				cursor: pointer;
			}

			.field-right-batch {
				flex-direction: row;
				align-items: center;

				.field-batch-text.placeholder + .field-arrow {
					color: @themeColor;
				}

				&.disabled {
					cursor: not-allowed;

					.field-batch-text,
					.field-arrow {
						color: @textColor13;
					}
				}
			}

			.field-scan-text {
				color: @themeColor;
				font-size: 0.16rem;
				letter-spacing: 0.01rem;
			}

			.field-value {
				color: @textColor12;
				font-size: 0.16rem;
				font-weight: 500;
				line-height: 0.22rem;
			}

			.field-rescan {
				color: @themeColor;
				font-size: 0.14rem;
				margin-top: 0.02rem;
			}

			.field-batch-text {
				color: @textColor12;
				font-size: 0.16rem;

				&.placeholder {
					color: @themeColor;
				}
			}

			.field-arrow {
				color: @textColor12;
				font-size: 0.14rem;
				margin-left: 0.05rem;
			}
		}

		.dialog-buttons {
			display: flex;
			justify-content: space-between;
			margin-top: 0.2rem;

			.dialog-btn {
				border-radius: 0.28rem;
				font-size: 0.16rem;
				letter-spacing: 0.02rem;
				line-height: 0.35rem;
				text-align: center;
				padding: 0 0.35rem;
				cursor: pointer;
			}

			.dialog-btn-cancel {
				background: @blank;
				border: 2px solid @themeColor;
				color: @themeColor;
			}

			.dialog-btn-confirm {
				background: @themeColor;
				border: 2px solid @themeColor;
				color: @blank;

				&.disabled {
					background: #C8C9CC;
					border-color: #C8C9CC;
					cursor: not-allowed;
				}
			}
		}
	}

	// 批次号选择器
	.picker-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 200;
		display: flex;
		align-items: flex-end;
		justify-content: center;
	}

	.picker-content {
		background: @blank;
		border-radius: 0.1rem 0.1rem 0 0;
		width: 100%;
		min-height: 30vh;
		max-height: 60vh;
		display: flex;
		flex-direction: column;

		.picker-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0.12rem 0.15rem;
			border-bottom: 1px solid @borderColor1;

			.picker-cancel {
				color: @textColor1;
				font-size: 0.16rem;
				cursor: pointer;
			}

			.picker-title {
				color: @textColor12;
				font-size: 0.17rem;
				font-weight: 500;
			}

			.picker-confirm {
				color: @themeColor;
				font-size: 0.16rem;
				cursor: pointer;
			}
		}

		.picker-list {
			overflow-y: auto;
			max-height: 50vh;
		}

		.picker-item {
			padding: 0.14rem 0.15rem;
			font-size: 0.16rem;
			color: @textColor1;
			text-align: center;
			border-bottom: 1px solid @borderColor1;
			cursor: pointer;

			&.active {
				color: @themeColor;
				font-weight: 500;
				background: @bgColor2;
			}
		}

		.picker-empty {
			padding: 0.3rem;
			text-align: center;
			color: @textColor13;
			font-size: 0.16rem;
		}
	}
}
</style>
